import script from "./Feed.vue?vue&type=script&setup=true&lang=js"
export * from "./Feed.vue?vue&type=script&setup=true&lang=js"

import "./Feed.vue?vue&type=style&index=0&id=01857ba7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01857ba7"]])

export default __exports__